goog.provide('el8.appshared.medOrderCQMCDS');

goog.require('el8.template.appshared.medorder.cqmcds');
goog.require('el8.data.decisionSupports');
goog.require('el8.appchart.cqmRefresh');

/**
 * deals with interaction between medorder form and CDS
 */
el8.appshared.medOrderCQMCDS = (function() {

    var latestMedicationId = null;
    var latestMedicationName = null;
    var container = null;

    var renderCDS = function(cdsItems) {
        if (container) {
            container.html(el8.template.appshared.medorder.cqmcds.cdsItems({
                cdsItems: cdsItems
            }));

            // set up link to detail of the CDS
            container.on('click', '.item-detail-trigger',  function() {
                var $alertItem = $(this).closest('.alert-item');
                var id = $alertItem.data('id');
                var item = el8.data.decisionSupports.getById(id);
                el8.appchart.visitNote.cdsDetailDialog.show({
                    nqfCode: item.getNqfCode()
                });
            });
        }
    }

    var fetchAndRenderCDS = function() {
        var renderingContext = {
            context: 'medorder'
        };
        el8.data.decisionSupports.getFeedIndex(function(index) {
            var cdsItems = [];
            _.each(index, function(cdsItemIdx) {
                var cdsItem = el8.data.decisionSupports.getById(cdsItemIdx.id);
                cdsItems.push(cdsItem.asSoyMap());
            });
            renderCDS(cdsItems);
        }, renderingContext, true);
    }

    el8.appchart.cqmRefresh.register({
        endCb: function(url, statusChanged) {
            if(statusChanged) {
                fetchAndRenderCDS();
            }
        }
    });

    return {

        /**
         * this (legacy) pattern is a bit retarted.  The
         * dialog is being reused and state needs to be cleaned up
         * after each use
         */
        reset: function() {
            latestMedicationId = null;
            latestMedicationName = null;
            renderCDS([]);
        },

        /**
         * called when a new medication is selected
         * this triggers a call to fetch relevant CDS and
         * render the banner
         */
        lookup: function(medicationId, medicationName, elt, successCb) {
            latestMedicationId = medicationId;
            latestMedicationName = medicationName;

            // TODO, use the actual selected medication to decide
            // if the med is actually high-risk
            // data might be in elation/quality_measures/definitions/CMS156/CMS156_2017.json
            // from Tim: this might be tricky to deal with this data in a generic way

            container = elt;
            if (el8Globals.FEATURES.CQMsForCPCPlus) {
                fetchAndRenderCDS();
            }
        }
    };

})();
